import { useCallback, useState } from 'react'
import { useIntl } from 'react-intl'
import Heading from 'LuxKit/Typography/Heading'
import TextButton from 'LuxKit/Button/TextButton'
import LineCheckIcon from 'LuxKit/Icons/line/LineCheckIcon'
import LineArrowLeftIcon from 'LuxKit/Icons/line/LineArrowLeftIcon'

import { useMessageActions } from 'tripPlanner/pages/chat/ChatTripPlannerPage/contexts/ChatMessageActionsContext'
import IconInCircle from 'tripPlanner/components/Icons/IconInCircle'
import CustomFlightContent from '../CustomFlightContent'
import { Card, CardContent, SuccessCard, SuccessHeader } from '../EmbeddedAccountAccess/components/shared'

interface Props {
  isLastMessage?: boolean
}

function ChatEmbeddedCustomFlight({ isLastMessage }: Props) {
  const intl = useIntl()
  const { onSendMessage } = useMessageActions()
  const [submitted, setSubmitted] = useState(false)
  const [title, setTitle] = useState(() => intl.formatMessage({
    id: 'iXuWvS8uvo92Ukh_mtl_',
    defaultMessage: 'Flight',
    description: 'Modal title for custom flight lookup in chat trip planner',
  }))
  const [onBack, setOnBack] = useState<(() => void) | undefined>(undefined)

  const handleDone = useCallback(() => {
    setSubmitted(true)
  }, [])

  const handleBackChange = useCallback((back: (() => void) | undefined) => {
    setOnBack(() => back)
  }, [])

  if (submitted) {
    return (
      <SuccessCard data-testid="embedded-custom-flight-success">
        <SuccessHeader>
          <IconInCircle icon={LineCheckIcon} circleColour="success" iconColour="neutral-eight" size={24} />
          <Heading variant="heading5" as="h3">{intl.formatMessage({
            id: 'Uy8B_aIPG4zFGTw79fKt',
            defaultMessage: 'Flight added',
            description: 'Success title after adding a custom flight inline in trip planner chat',
          })}
          </Heading>
        </SuccessHeader>
      </SuccessCard>
    )
  }

  return (
    <Card data-testid="embedded-custom-flight">
      <CardContent>
        {onBack && (
          <div>
            <TextButton kind="tertiary" variant="dark" size="small" onClick={onBack} startIcon={<LineArrowLeftIcon />}>
              {intl.formatMessage({
                id: 'hGloSRxkmfJvkZ5EFWUh',
                defaultMessage: 'Back',
                description: 'Back button label in inline custom flight results step in trip planner chat',
              })}
            </TextButton>
          </div>
        )}

        <Heading variant="heading5" as="h3">{title}</Heading>

        <CustomFlightContent
          onSendMessage={onSendMessage}
          onDone={handleDone}
          onTitleChange={setTitle}
          onBackChange={handleBackChange}
          autoFocus={isLastMessage}
        />
      </CardContent>
    </Card>
  )
}

export default ChatEmbeddedCustomFlight
